module.exports = __webpack_public_path__ + "static/media/thirdparty.7adadd6b.png";